import React from 'react';
import useChart from '../../../../hooks/generic/charts/useChart';

const defaultChartOptions = {
  chart: {
    type: 'pie'
  },
  title: {
      text: null
  },
  legend: {
    layout: 'vertical',
    align: 'right',
    verticalAlign: 'middle',
    symbolRadius: 3,
    itemMarginTop: 12,
    itemMarginBottom: 12,
    itemStyle: {
      "fontWeight": "normal"
    }
  },
  plotOptions: {
    pie: {
      borderWidth: 5,
    }
  },
  credits: {
    enabled: false
  }
}

const PieChart = (props) => {
  const [HighchartsComponent, highchartsOptions] = useChart({
    chartOptions: {
      defaultOptions: defaultChartOptions,
      primaryOptions: props.chartOptions
    },
    configs: props.configs
  });

  return(
    <HighchartsComponent { ...highchartsOptions } callback={ props.callbackFn } />
  )
}

export default PieChart;
